export default "__VITE_ASSET__T$u2kL2z__"